
<div class="border-div margin0 min-heightcontainer property-more-details-box">
    <div class="d-flex data-filter-header">
        <h2 class="mainhead mr-auto" style="width:100%">
            <span class="text" *ngIf="!property.IsPortfolio">Property History</span>
            <span class="text" *ngIf="property?.IsPortfolio">Porfolio History</span>
        </h2>
        <button *ngIf="showAddHistory && (authService.Admin()||authService.SuperAdmin())" type="button" class="btn  btn-circle btn-green margin-bottom"
                [disabled]="disableAddEditHistoryButton" aria-controls="dropdown-basic" (click)="openHistoryAdd()" tooltip="{{this.activeTab == historyTabs.SaleHistory ? 'Add New Sale History' : 'Add New Leasing History' }}" placement="left">
            <i aria-hidden="true" class="fa fa-plus icon"></i>
        </button>
    </div>
    <div class="clearfix"></div>
    <div class="floatinghead be-tab-02 clearfix" style="margin:0;">
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a href="javascript:void(0);" (click)="onTabClick(historyTabs.SaleHistory, 6500)" class="nav-link" [ngClass]="{'active' : activeTab == historyTabs.SaleHistory }">Sale History</a>
            </li>
            <!--<li>
                <a href="javascript:void(0);" (click)="onTabClick()" class="nav-link" [ngClass]="{'active' : this.activeTab == historyTabs.SaleHistory }">Price history</a>
           </li>-->
            <li *ngIf="!property.IsPortfolio">
                <a href="javascript:void(0);" (click)="onTabClick(historyTabs.LeasingHistory, 6501)" class="nav-link" [ngClass]="{'active' : activeTab == historyTabs.LeasingHistory }">Leasing History</a>
            </li>
        </ul>
        <!--<div class="mainhead " (click)="onTabClick(historyTabs.SaleHistory)"><span class="text">Sale History</span></div>
        <h4 class="mainhead " (click)="onTabClick()"><span class="text">Price history</span></h4>
        <h4 class="mainhead " (click)="onTabClick(historyTabs.LeasingHistory)"><span class="text">Leasing History</span></h4>-->
        <div class="rightside clearfix">
        </div>
    </div>
    <div class="offredetailspage">
        <div>
            <div class="row" *ngIf="activeTab == historyTabs.LeasingHistory">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <app-sale-history-list (disableAddEditHistoryButton)="disableButton($event)" [propertyId]="propertyId" [IsPDeleted]="IsPDeleted" [IsDataEntryPrperty]="IsDataEntryPrperty" [canEditHistory]="canEditHistory" [transactionTypeId]="transactionTypeId"></app-sale-history-list>
                </div>
            </div>
            <div class="row"  *ngIf="activeTab == historyTabs.SaleHistory">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <app-sale-history-list (disableAddEditHistoryButton)="disableButton($event)"  [propertyId]="propertyId" [IsPDeleted]="IsPDeleted" [IsDataEntryPrperty]="IsDataEntryPrperty" [canEditHistory]="canEditHistory" [transactionTypeId]="transactionTypeId"></app-sale-history-list>
                </div>
            </div>
        </div>
    </div>
</div>


<!--<ng-template #templateLeasingHistory>
    <app-add-leasing-history (save)="saveLeasingHistory(LeasingHistory)" [LeasingHistory]="LeasingHistory" (close)="closeModal($event)" ></app-add-leasing-history>
</ng-template>-->
